import {Button, Checkbox, Table} from "omoplay";
import {useEffect, useState} from "react";
import {getProductList} from "../../api/product/product.api";
import moment from "moment";

export const ProductConnectionList = ({onChecked, isMultiple}) => {
    const [productTableList, setProductTableList] = useState([])
    const [totalSize, setTotalSize] = useState(0)
    const [checkedIds, setCheckedIds] = useState([])
    const rowSize = 5

    const headers = [
        { name: "", width: "60px", align: "center" }, { name: "상품명" },
        { name: "카테고리", width: "170px" }, { name: "원가", width: "100px", align: "center" },
        { name: "생성일", width: "120px", align: "center" }, {name: "", width: "140px"}
    ]

    useEffect(() => {
        onChecked(checkedIds)
    }, [checkedIds]);

    useEffect(() => {
        getProductList(null, true).then(({data}) => {
            setTotalSize(data.first.length)
            setProductTableList(data.first.map(product => {
                const info = product.info
                if (!info) {
                    return []
                }

                return [
                    <div className="flex-align-center h-full">
                        <Checkbox key={product.id} checked={checkedIds.find(check => check === product.id)} item={{label: "", value: product.id}}
                                  onChecked={(checked, item) => {
                                      setCheckedIds((prevIds) => {
                                          if (checked) {
                                              return [...prevIds, item.value];
                                          } else {
                                              return prevIds.filter((existingId) => existingId !== item.value);
                                          }
                                      });
                                  }} />
                    </div>,
                    <div className="flex">
                        <div><img src={info.images[0]} width="48px" height="48px" /></div>
                        <div>{info.productName}</div>
                    </div>,
                    <div>{info.category}</div>,
                    <div>{info.originalPrice?.toLocaleString()}</div>,
                    <div className="text-center">{moment(product.createdAt).format("YYYY-MM-DD HH:mm")}</div>,
                    <div>{!isMultiple && (<div><Button variants="dark" value="선택하기" onClick={() => onChecked(product.id)} /></div>)}</div>
                ]
            }))
        })
    }, [])

    return (
        <>
            <div className="flex-col gap-4" style={{marginTop: "24px"}}>
                {/*
                <div className="flex justify-between gap-4">
                    <div className="flex-1">
                        <TextInput showIcon={true} placeholder="검색어를 입력해 주세요." />
                    </div>
                </div>
                */}
                <div>
                    <Table headers={headers} data={productTableList} pagination={{
                        rowSize: rowSize,
                        totalSize: totalSize,
                        pageSize: 6
                    }}
                    />
                </div>
            </div>
        </>
    )
}

export default ProductConnectionList
